import React from 'react';
import { connect } from 'react-redux';
import Tab from '../../../common/tab-timer';
import { getQueryParams } from '../../../helpers/Common';
import Overview from './overview/Overview';
import Value from './value/Value';
import Growth from './growth/Growth';
import Momentum from './momentum/Momentum';
import VMG from './vmg/VMG';
import Leaders from './leaders/Leaders';
import { REDUCER_NAME, setTypeRanking } from './reducer';
import Const from './Const';
import ConstCommon from './../../../common/Const';
import currentState from './../../../helpers/CurrentState';
import './index.scss';
const MIN_WIDTH = 690;

const mapTab = {
  Overview: 1,
  Value: 2,
  Growth: 3,
  Momentum: 4,
  VGM: 5,
  Leaders: 6,
};

class FiinTradeStrategy extends React.Component {
  constructor(props) {
    super(props);
    const tabFromQuery = mapTab[getQueryParams('option')];
    this.state = {
      currentTab:
        tabFromQuery ||
        props.subTab ||
        currentState.get(
          ConstCommon.listComponent.Strategy,
          'FiintradeStrategy.currentTab',
        ) ||
        1,
    };
  }

  changeType = currentTab => {
    if (currentTab !== this.state.currentTab) {
      currentState.add(
        ConstCommon.listComponent.Strategy,
        'FiintradeStrategy.currentTab',
        currentTab,
      );
      this.setState({ currentTab });
      this.props.setTypeRanking(Const.DEFAULT_INDUSTRY);
    }
  };

  render() {
    const {
      component: { width },
    } = this.props;
    const extraClassName = width < MIN_WIDTH ? 'fs-ta-chart-wrapper' : '';
    return (
      <div
        className={`tab-pane active d-flex flex-column h-auto w-100 ${extraClassName}`}
      >
        <div className="w-100 px-20">
          <div className="list-filter top-nav">
            <Tab
              currentTab={this.state.currentTab}
              listTab="strategy.listFiintrade"
              changeTab={this.changeType}
            />
          </div>
        </div>
        {this.state.currentTab === 1 && <Overview />}
        {this.state.currentTab === 2 && <Value />}
        {this.state.currentTab === 3 && <Growth />}
        {this.state.currentTab === 4 && <Momentum />}
        {this.state.currentTab === 5 && <VMG />}
        {this.state.currentTab === 6 && <Leaders />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    component: state[REDUCER_NAME].component,
    i18n: state.i18n,
    typeRanking: state[REDUCER_NAME].typeRanking,
  };
};

const mapDispatchToProps = {
  setTypeRanking,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FiinTradeStrategy);
